import Vue from 'vue'

import WebLink from '@/views/WebLink.vue'
import weblink from '@/api/weblink'

import LandingPage from '@/views/LandingPage.vue'
import landingpage from '@/api/landingpage'

import GuestDocumentation from '@/views/GuestDocumentation.vue'
import guestdocumentation from '@/api/guestdocumentation'

const getItineraryBySourceTypeText = (data, sourceTypeTexts, isAgent = false) => {
  let opportunityCloned = { ...data }

  const itinerarySelected = data.data.itineraries
    .find(it => sourceTypeTexts.includes(it.itinerary_source_type_text))

  if (itinerarySelected) {
    delete opportunityCloned.data.itineraries
    opportunityCloned.isAgent = isAgent
    opportunityCloned.data['itineraries'] = itinerarySelected
    return opportunityCloned
  }

  return {}
}

const fetchWeblink = (sourceTypeTexts, to, next, isAgent = false) => {
  const uuid = to.params.uuid
  Vue.prototype.$spinner.show()
  weblink.getData(uuid)
    .then((response) => {
      Vue.prototype.$spinner.hide()
      to.params.data = getItineraryBySourceTypeText(response.data, sourceTypeTexts, isAgent)
      to.params.uuid = uuid
      return next()
    })
    .catch(() => {
      Vue.prototype.$spinner.hide()
      to.params.data = {}
      return next()
    })
}

const routes = [
  {
    path: '/weblink/:uuid',
    name: 'weblink',
    component: WebLink,
    props: true,
    beforeEnter (to, from, next) {
      fetchWeblink(['ITP-Uniworld', 'ITP'], to, next)
    }
  },
  {
    path: '/proposal/:uuid',
    name: 'proposal',
    component: WebLink,
    props: true,
    beforeEnter (to, from, next) {
      fetchWeblink(['ITP'], to, next, true)
    }
  },
  {
    path: '/landingpage/:uuid',
    name: 'landingpage',
    component: LandingPage,
    props: true,
    beforeEnter (to, from, next) {
      const uuid = to.params.uuid
      Vue.prototype.$spinner.show()
      landingpage.getData(uuid)
        .then((response) => {
          Vue.prototype.$spinner.hide()
          to.params.data = getItineraryBySourceTypeText(response.data, ['ITP-FLYER'])
          to.params.uuid = uuid
          return next()
        })
        .catch(() => {
          Vue.prototype.$spinner.hide()
          to.params.data = {}
          return next()
        })
    }
  },
  {
    path: '/guestdocumentation/:uuid',
    name: 'guestdocumentation',
    component: GuestDocumentation,
    props: true,
    beforeEnter (to, from, next) {
      const uuid = to.params.uuid
      Vue.prototype.$spinner.show()
      guestdocumentation.getData(uuid)
        .then((response) => {
          Vue.prototype.$spinner.hide()
          to.params.data = getItineraryBySourceTypeText(response.data, ['ITP-GUEST'])
          to.params.uuid = uuid
          return next()
        })
        .catch(() => {
          Vue.prototype.$spinner.hide()
          to.params.data = {}
          return next()
        })
    }
  },
  {
    path: '/404',
    name: '404',
    component: () => import(/* webpackChunkName: "notfound" */ '@/views/NotFound.vue')
  },
  {
    path: '*',
    redirect: { name: '404' }
  }
]

export default routes
